<template>
  <div class="modal-popup">
    <div class="modal fade" id="exchangeRateHistoryPopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="title mt-2 ml-2">Kur Geçmişi</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-box">
                      <label class="label-text">Hedef Tarih</label>
                      <div class="input-box">
                        <input class="form-control" v-model="targetDate" id="targetDate" type="date" placeholder="">
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <label class="label-text"> - </label>
                    <div class="input-box">
                      <button @click="getExchangeRateAt" class="theme-btn theme-btn-small" type="button" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                        Getir
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-box">
                      <label class="label-text">EUR/TL Rate</label>
                      <input disabled class="form-control" v-model="targetExchangeRate" id="exchangeRate" type="text" placeholder="">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "ExchangeRateHistoryPopup",
  data:function (){
    return{
      targetDate: null,
      targetExchangeRate : null,
      exchangeRateHistory : null
    }
  },
  computed:{
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList
      }
    },
    booking:{
      get(){
        return this.$store.getters.getBooking
      }
    }
  },
  methods:{
    getExchangeRateAt(){
      let targetDateParsed = new Date(this.targetDate);

      this.targetExchangeRate = this.exchangeRateHistory.sort((a, b) => {
        return ((targetDateParsed - a.date) > (targetDateParsed - b.date)) ? 1 : -1
      })[0].exchangeRate;
    },
    copyToClipboard(txt) {
      var x = document.getElementById("snackbar");

      $(document.getElementById("snackbar")).html("Ödeme adresi kopyalandı")
      // Add the "show" class to DIV
      x.className = "show";

      // After 3 seconds, remove the show class from DIV
      setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
        var m = document;
        txt = m.createTextNode(txt);
        var w = window;
        var b = m.body;
        b.appendChild(txt);
        if (b.createTextRange) {
          var d = b.createTextRange();
          d.moveToElementText(txt);
          d.select();
          m.execCommand('copy');
        }
        else {
          var d = m.createRange();
          var g = w.getSelection;
          d.selectNodeContents(txt);
          g().removeAllRanges();
          g().addRange(d);
          m.execCommand('copy');
          g().removeAllRanges();
        }
        txt.remove();
    },
    accept(){
      if(this.remotePayment.paymentAmount != null){
        this.remotePayment.bookingId = this.booking.id
        this.$store.dispatch("remotePayment",this.remotePayment).then(response => {
          this.paymentUrl = response.data.paymentUrl;
        }).catch(error => {
          messagePopupManager.showError("Hata", error.response.data.message);
        })
      }else{
        $("#selectedAgency").addClass("error");
        $("#paymentAmount").addClass("error");
      }

    }
  },
  mounted() {
    this.$store.dispatch("loadExchangeRateHistoryList").then((response)=>{
      this.exchangeRateHistory = response;
    })
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>

</style>